import {
  MOBILE_HOME_HEADER_BUTTON_HITSLOP_SIZE,
  MOBILE_HOME_HEADER_ICON_SIZE,
} from 'app/components/mobile-home-header-constants';
import { MagicWand } from 'app/design/icons/magic-wand';
import { Button } from 'app/design/primitives/button';

import { useAuthorize } from 'app/hooks/use-authorize';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

interface GiftButtonProps {
  onPress: () => void;
  size?: number;
  iconSize?: number;
  accessibilityLabel?: string;
}

export function GiftButton({
  onPress,
  accessibilityLabel,
  size = MOBILE_HOME_HEADER_BUTTON_HITSLOP_SIZE,
  iconSize = MOBILE_HOME_HEADER_ICON_SIZE,
}: GiftButtonProps) {
  const withAuthorize = useAuthorize();
  const onPressWithAuthorize = () => withAuthorize(onPress);

  return (
    <Button
      onPress={onPressWithAuthorize}
      accessibilityLabel={accessibilityLabel}
      variant="plain"
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <MagicWand color={theme.colors['text.primary']} width={iconSize} height={iconSize} />
    </Button>
  );
}
